module.exports = __webpack_public_path__ + "img/DE00647.4fd4f9b3.png";